const imageType = [
    'image/png',
    'image/jpg',
    'image/jpeg'
]
const MAX_FILE_SIZE_IMAGE = 1 * 1024 * 1024 //1 MB
const MAX_FILE_SIZE_VIDEO = 30 * 1024 * 1024 //30 MB

const videoType = [
    'video/mp4',
];
const invalidImageMessage = `Please select a valid image file. Allowed types: ${imageType.map(type => type.split('/')[1]).join(', ')}`;
const imageSizeExceededMessage = `The image file size should not exceed ${MAX_FILE_SIZE_IMAGE / (1024 * 1024)} MB.`;
const invalidVideoMessage = `Please select a valid video file. Allowed types: ${videoType.map(type => type.split('/')[1]).join(', ')}`;
const videoSizeExceededMessage = `The video file size should not exceed ${MAX_FILE_SIZE_VIDEO / (1024 * 1024)} MB.`;

module.exports = { videoSizeExceededMessage, invalidImageMessage, imageSizeExceededMessage, invalidVideoMessage, imageType, MAX_FILE_SIZE_IMAGE, MAX_FILE_SIZE_VIDEO, videoType }